import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Subject} from 'rxjs';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'app-confirm-dialog',
  styleUrls: ['./confirm-dialog.component.scss'],
  templateUrl: './confirm-dialog.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ConfirmDialogComponent implements OnInit {

  @Input() message: string;
  @Input() confirmButtonMessage: string | null;
  @Input() isConfirmCheckBoxLabel: string | null;
  @Input() confirmationMessageRequired: boolean | null | undefined;
  @Input() isConfirmCheckbox: boolean | null | undefined;

  public safeMessage: SafeHtml;
  public isConfirmCheckboxValue = false;

  public confirmationMessage = '';

  destroy = new Subject<any>();
  currentDialog = null;
  errorMessage: string;

  constructor(private activeModal: NgbActiveModal, private sanitizer: DomSanitizer) {

  }

  closeModal(sendData): void {
    const data: any = {
      status: sendData,
    };
    if (!this.confirmationMessageRequired) {
      data.confirmationMessage = this.confirmationMessage;
    }

    if (this.isConfirmCheckbox) {
      data.checkboxValue = this.isConfirmCheckboxValue;
    }

    this.activeModal.close(data);
  }

  ngOnInit(): void {
    this.safeMessage = this.sanitizer.bypassSecurityTrustHtml(this.message);
  }
}
